<template lang="pug">
  .selector
    .selector_selected(v-on:click="toggleAccordion" v-bind:class="{'selector_selected-disabled': disabled, 'selector_selected-none': !selected, 'selector_selected-filled': fill_color}" v-bind:style="fill_color")
      selectorLabel(:option="current", :is_ja="is_ja")
      .selector_icon
        hamburger(v-bind:disabled="disabled" v-bind:none="!selected" v-bind:filled="fill")
    .selector_pulldown(v-bind:class="{'selector_pulldown-active': isOpen, 'selector_pulldown-upper': pulltype == 'upper'}" )
      .selector_scroll.selector_scroll-upper(v-bind:class="{'selector_scroll-active': isScrollable, 'selector_scroll-enabled': !isScrollAtTop && isScrollable}" v-on:click="onScrollUp" )
        svg.selector_scrollIcon.selector_scrollIcon-upper(xmlns="http://www.w3.org/2000/svg" width="10" height="5" viewBox="0 0 10 5" v-bind:class="{'selector_scrollIcon-active': isScrollable,'selector_scrollIcon-enabled': !isScrollAtTop}")
          polygon(points="0,5 5,0 10,5")
      .selector_optionList( ref="scrollBox" v-on:scroll="onScroll" v-bind:class="{'selector_optionList-scrollable': isScrollable}" v-on:transitionend="onTE")
        .selector_option(v-for="(option, index) in value_type" v-bind:class="{'selector_option-selected': index == selected_index}" v-on:click="selectCell(option)" )
          selectorLabel(:option="option", :is_ja="is_ja")
      .selector_scroll.selector_scroll-lower(v-bind:class="{'selector_scroll-active': isScrollable, 'selector_scroll-enabled': !isScrollAtBottom && isScrollable}" v-on:click="onScrollDown")
        svg.selector_scrollIcon.selector_scrollIcon-lower(xmlns="http://www.w3.org/2000/svg" width="10" height="5" viewBox="0 0 10 5" v-bind:class="{'selector_scrollIcon-active': isScrollable,'selector_scrollIcon-enabled': !isScrollAtBottom}")
          polygon(points="0,0 10,0 5,5")

</template>
<script>
  import {mapState} from 'vuex';
  import _ from 'lodash';

  import Hamburger from './hamburger.vue';
  import SelectorLabel from './selectorLabel';

  let height_rate = 0.5;


  export default{

    props: ['value_type','selected','pulltype', 'none_value', 'disabled', 'fill'],
    data: function(){
      return {
        isOpen: false,
        isScrollable: false,
        scrollTop: -1
      }
    },
    computed: {
      ...mapState([
        'lang',
        'size',
        'ageStandardizedWord',
      ]),
      win_height(){
        return this.size.window.height;
      },
      current(){
        if( this.selected ){
          if( _.isObject(this.selected)){
            return this.selected;
          }else{
            let filtered = _.filter(this.value_type, (o)=>{
              return o.value === this.selected;
            });
            return filtered[0];
          }
        }else{
          return this.none_value;
        }
      },
      hasageStandardizedWord(){
        return _.isBoolean(this.current.ageStandardized);
      },
      ageStandardizedLabel(){
        if(this.current.ageStandardized){
          return this.ageStandardizedWord[this.lang][0];
        }else{
          return this.ageStandardizedWord[this.lang][1];
        }
      },
      selected_index: function(){
        return this.value_type.indexOf(this.current);
      },
      isScrollAtTop: function(){
        return this.isScrollable && this.scrollTop <= 0;
      },
      isScrollAtBottom: function(){
        if( this.isScrollable ){
          let num_cell = this.value_type.length;
          let cell_height = 30;
          let in_scroll_area_height = cell_height * num_cell;

          let scroll_area_height = this.$refs.scrollBox.clientHeight;

          let max_scroll_value = in_scroll_area_height - scroll_area_height;

          return this.scrollTop >= max_scroll_value;
        }else{
          return false;
        }
      },
      fill_color(){
        if( this.fill && this.selected ){
          return {
            backgroundColor: '#' + this.fill
          };
        }else{
          return false;
        }
      },
      is_ja(){
        return /ja/.test(this.lang)
      }

    },
    watch: {
      'size.window.height': function(){
        this.checkScrollable();
      }
    },
    methods: {
      toggleAccordion: function(){
        if( this.disabled ){
          this.isOpen = false;
        }else{
          this.checkScrollable();
          this.isOpen = !this.isOpen;
        }
      },
      selectCell: function(value){
        this.$emit('select_value_type', value);
        this.isOpen = false;
      },
      onScroll: function(e){
        this.scrollTop = e.target.scrollTop;
      },
      onTE: function(){
        this.scrollTop = this.$refs.scrollBox.scrollTop;
      },
      onScrollDown: function(){
        this.$refs.scrollBox.scrollTop = Math.min(this.get_maxValueOfScrollTop() , this.$refs.scrollBox.scrollTop + 30);
        this.scrollTop = this.$refs.scrollBox.scrollTop;
      },
      onScrollUp: function(){
        this.$refs.scrollBox.scrollTop = Math.max(0, this.$refs.scrollBox.scrollTop - 30);
        this.scrollTop = this.$refs.scrollBox.scrollTop;
      },
      get_scrollBoxHeight: function(){
        let button_height = this.isScrollable ? 30 : 10;
        return this.win_height * height_rate - button_height * 2;
      },
      get_insideScrollBoxHeight: function(){
        let num_cell = this.value_type.length;
        let cell_height = 30;
        return cell_height * num_cell;
      },
      get_maxValueOfScrollTop: function(){
        let sbh = this.get_scrollBoxHeight();
        let isbh = this.get_insideScrollBoxHeight();

        return isbh - sbh;
      },
      checkScrollable: function(){
        let wh = this.win_height;
        if( wh == 0){
          this.isScrollable = false;
          this.scrollTop = -1;
        }else{
          let scrollBoxHeight = this.win_height * height_rate - 20;
          let insideScrollBoxHeight = this.get_insideScrollBoxHeight();

          this.isScrollable =  scrollBoxHeight < insideScrollBoxHeight;
          this.scrollTop = -1;

        }
      }

    },
    components: {
      hamburger: Hamburger,
      selectorLabel: SelectorLabel,
    }
  }

</script>
<style lang="sass">
  $pulldown_height: 50vh
  .selector
    width: 100%
    height: 40px
    position: relative
    &_selected
      display: flex
      justify-content: space-between
      flex-direction: row
      align-items: center
      background-color: #000
      color: #fff
      font-size: 14px
      font-weight: bold
      border-radius: 5px
      cursor: pointer
      box-sizing: border-box
      padding: 0 15px
      height: 100%
      transition: background-color .1s linear, color .1s linear
      &-filled
        color: #000
      &-none
        background-color: #cccccc
        color: #000
      &-disabled
        background-color: #cccccc
        color: #666666
        cursor: default
    &_pulldown
      max-height: 0
      overflow: hidden
      transition: max-height .1s linear
      position: absolute
      top: 40px
      left: 0
      width: 100%
      border-radius: 5px
      box-shadow: 0 2px 4px rgba(0, 0, 0, .5)
      &-upper
        top: auto
        bottom: 40px
      &-active
        max-height: $pulldown_height
    &_scroll
      height: 30px
      max-height: 10px
      background-color: #ccc
      display: flex
      justify-content: center
      align-items: center
      transition: max-height .1s linear
      &-upper
      &-lower
      &-active
        max-height: 30px
      &-enabled
        &:hover
          background-color: #666
          cursor: pointer
    &_scrollIcon
      fill: #ddd
      display: none
      &-active
        display: block
      &-enabled
        fill: #fff

    &_optionList
      max-height: calc(#{$pulldown_height} - 20px)
      overflow: auto
      transition: max-height .1s linear
      &-scrollable
        max-height: calc(#{$pulldown_height} - 60px)
    &_option
      text-align: left
      width: 100%
      height: 30px
      font-size: 14px
      font-weight: bold
      cursor: pointer
      box-sizing: border-box
      padding: 0 15px
      background-color: #fff
      display: flex
      justify-content: flex-start
      align-items: center
      &:nth-child(2n)
        background-color: #F2F2F2
      &:hover
        background-color: #F0DC00
        color: #000
      &-selected, &-selected:nth-child(2n)
        background-color: #000
        color: #fff
</style>